var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"inline-block header-logo",class:[_vm.theme, { 'shadow': _vm.shadow, 'reverse': _vm.reverse }],attrs:{"to":"/"}},[_c('svg',{staticClass:"inline-block"},[_c('use',{attrs:{"xlink:href":"#icon-logo-image"}})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18e282d1","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/layout/header/logo.vue
// module id = null
// module chunks = 